import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import DevelopmentBanner from "../../components/pages/Services/Development/DevelopmentBanner/DevelopmentBanner";
import WhatWeSolve from "../../components/pages/Services/Development/WhatWeSolve/WhatWeSolve";
import WhatsIncluded from "../../components/pages/Services/Development/WhatsIncluded/WhatsIncluded";
import DevProcess from "../../components/pages/Services/Development/DevProcess/DevProcess";
import WhyUs from "../../components/pages/Home/WhyUs/WhyUs";
import HostingPlans from "../../components/pages/Services/Development/HostingPlans/HostingPlans";
import Enables from "../../components/pages/Industries/Enables/Enables";
import ExtraOrdinary from "../../components/pages/Services/ExtraOrdinary/ExtraOrdinary";

export default function ServicePageLayout({ showHostingPlans = false }) {
  return (
    <div>
      <Navbar />
      <DevelopmentBanner />
      <WhatWeSolve />
      <WhatsIncluded />
      {showHostingPlans ? <HostingPlans /> : null}
      <DevProcess />
      <WhyUs />
      <Enables />
      <ExtraOrdinary />
      <Footer />
    </div>
  );
}
